<template>
  <div class="AssetCategory">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-tabs ref="tabs" v-model="activeTab" type="card">
        <el-tab-pane label="전체계정" name="1">
          <AssetCategoryView/>
        </el-tab-pane>
        <el-tab-pane label="수입계정" name="2">
          <AssetCategoryReg
            v-if="activeTab === '2'"
            :type_id="1"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="지출계정" name="3">
          <AssetCategoryReg
            v-if="activeTab === '3'"
            :type_id="2"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="계정설정" name="4">
          <AssetCategoryConfig
            v-if="activeTab === '4'"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { authority_level } from "@/common/mixins/authority_level";
import AssetCategoryReg from "./AssetCategoryReg";
import AssetCategoryView from "./AssetCategoryView";
import AssetCategoryConfig from "./AssetCategoryConfig";

export default {
  name: "Account",
  mixins: [authority_level],
  components: {AssetCategoryReg, AssetCategoryView, AssetCategoryConfig},
  data() {
    return {
      title: this.$t("title.asset_category"),
      activeTab: '1',
    }
  },
  computed: {
    has_grant_write() {
      return this.isWriteLevel('asset_category');
    },
  },
}
</script>
